interface LoadingScreenProps {
  message?: string;
}

export function LoadingScreen({ message = "Loading..." }: LoadingScreenProps): React.ReactNode {
  return (
    <div
      data-testid="loading-screen"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        background: "#000510",
        color: "#00ddff",
        fontFamily: "'Orbitron', system-ui, sans-serif",
        gap: 24,
      }}
    >
      <div
        style={{
          width: 40,
          height: 40,
          border: "2px solid rgba(0, 221, 255, 0.2)",
          borderTopColor: "#00ddff",
          borderRadius: "50%",
          animation: "pe-spin 0.8s linear infinite",
        }}
      />
      <p style={{ fontSize: 14, letterSpacing: 2, color: "rgba(255,255,255,0.6)" }}>
        {message}
      </p>
      <style>{`
        @keyframes pe-spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
